import api from '../../axios_api'
import _ from 'lodash'
import Promise from 'bluebird'
import router from '../../main'


const state = {
    diligences: []
}

const getters = {
    diligenceData: (state) => state.diligences,
    diligenceCount: function (state) {
        return state.diligences.length
    },
    activeDiligenceData: function (state, getters, rootState, rootGetters) {
        let retval = JSON.parse(JSON.stringify(state.diligences));
        let diligenceStageData = rootGetters['diligence_stage/diligenceStageData'];
        return _.filter(retval, function (obj) {
            if (obj.deal_stage) {
                let stageName = diligenceStageData.find(
                    stage => stage._id == obj.deal_stage
                );
                if (stageName) obj.dealStageName = stageName.stage_name;
            }
            return obj && obj.dealStageName != "Pass" && obj.dealStageName != "Invest" && !obj.is_archive
        })
    },
    archivedDiligenceData: function (state, getters, rootState, rootGetters) {
        let retval = JSON.parse(JSON.stringify(state.diligences));
        let diligenceStageData = rootGetters['diligence_stage/diligenceStageData'];
        return _.filter(retval, function (obj) {
            if (obj.deal_stage) {
                let stageName = diligenceStageData.find(
                    stage => stage._id == obj.deal_stage
                );
                if (stageName) obj.dealStageName = stageName.stage_name;
            }
            return obj && obj.dealStageName != "Invest" && (obj.dealStageName == "Pass" || obj.is_archive)
        })
    },
}
const mutations = {
    initialize(state) {
        state.diligences = []
    },
    merge(state, payload) {
        // merge our local with what has returned
        if (_.isNil(payload) || _.isEmpty(payload)) return
        if (!_.isArray(payload)) payload = [payload]
        // state.diligences = payload;
        state.diligences = _.map(state.diligences, addr => {
            let index = _.findIndex(payload, function (a) { return a._id === addr._id })
            if (index >= 0) {
                return _.first(_.pullAt(payload, index))
            }
            return addr
        })
        if (!_.isEmpty(payload)) state.diligences = _.concat(state.diligences, payload)
        state.diligences = _.without(state.diligences, null, undefined)
    },
    remove(state, payload) {
        if (_.isNil(payload) || _.isEmpty(payload)) return
        // remove the item by the id (either _id or uaid)
        state.diligences = _.filter(state.diligences, function (a) { return a._id !== payload && a.uaid !== payload })
    },
    overwrite(state, payload) {
        state.diligences = payload
    }
}

const actions = {
    start({ state, dispatch, commit }) {
        commit('initialize')
        dispatch('apiFetchDiligence')
            .then(() => {
            })
            .catch(() => { })
    },
    merge(state, payload) {
        // merge our local with what has returned
        if (_.isNil(payload) || _.isEmpty(payload)) return
        if (!_.isArray(payload)) payload = [payload]
        state.diligences = payload
    },
    stop({ commit }) {
        // clean up
        commit('initialize')
    },
    apiFetchDiligence({ commit, dispatch }) {
        if (localStorage.fiifi) {
            let fiifi = JSON.parse(localStorage.fiifi).user
            if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
                let url = `${fiifi.id}/${fiifi.workspace_id}/diligence`;
                api.get(url)
                    .then(res => {
                        commit('merge', JSON.parse(JSON.stringify(res.data.encrypt.dilignceData)))
                        return Promise.resolve(res.data.encrypt.dilignceData)
                    })
                    .catch(err => {
                        return Promise.reject(err)
                    })
            }
        }
    },
    apiCleanFetchDiligence({ commit, dispatch }) {
        if (localStorage.fiifi) {
            let fiifi = JSON.parse(localStorage.fiifi).user
            if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
                let url = `${fiifi.id}/${fiifi.workspace_id}/diligence`;
                api.get(url)
                    .then(res => {
                        commit('overwrite', res.data.encrypt.dilignceData)
                        return Promise.resolve(res.data.encrypt.success)
                    })
                    .catch(err => {
                        return Promise.reject(err)
                    })
            }
        }
    },
    apiPostDiligenceInst({ rootGetters, dispatch }, payload) {
        // payload should be a company instance
        let currentRole = rootGetters['role/current_role'];
        let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/diligence/company`;
        return api.post(url, { encrypt: { data: payload } })
            .then(res => {

                // res should be the updated company info
                dispatch('apiFetchDiligence')
                    .then(() => {
                    })
                    .catch(() => { })
                return Promise.resolve(res.data.encrypt)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiPatchDiligenceInst({ dispatch }, payload) {
        // payload should be a Company instance
        let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/diligence`;

        return api.patch(url, { encrypt: { data: payload } })
            .then(res => {
                dispatch('apiFetchDiligence')
                    .then(() => {
                    })
                    .catch(() => { })
                return Promise.resolve(res.data.encrypt)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiPatchDiligenceStageInst({ dispatch }, payload) {
        let url = `diligence_stage/note/${router.currentRoute.params.workspace_id}`;
        return api.patch(url, { encrypt: { data: payload } })
            .then(res => {
                dispatch('apiFetchDiligence')
                    .then(() => {
                    })
                    .catch(() => { })
                return Promise.resolve(res.data.encrypt.success)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiStatusUpdate({ dispatch }, payload) {
        let url = `/diligence/status/update`;
        return api.patch(url, { encrypt: { data: payload } })
            .then(res => {
                dispatch('apiFetchDiligence')
                    .then(() => {
                    })
                    .catch(() => { })
                return Promise.resolve(res.data.encrypt)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiDeleteDiligence({ dispatch, commit }, payload) {
        let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/diligence/${payload.ucid}`;
        return api.delete(url)
            .then(res => {
                // commit('remove', payload._id)
                return Promise.resolve(res.data.encrypt)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiDeleteDiligenceReferrs({ dispatch }, payload) {
        let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/diligence/referrers/${payload._id}`;
        return api.delete(url)
            .then(res => {
                return Promise.resolve(res.data.encrypt)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    },
    apiPatchPortfolioInfo({ dispatch }, payload) {
        let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/diligence/portfolio/info`;
        return api.patch(url, { encrypt: { data: payload } })
            .then(res => {
                return Promise.resolve(res.data.encrypt)
            })
            .catch(err => {
                return Promise.reject(err)
            })
    }

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}